import React, { useState } from 'react';
import Modal from './Modal';
import { RecurrenceScope } from '../types';

interface RecurrenceScopeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (scope: RecurrenceScope) => void;
    title: string;
    description: string;
    itemDescription?: string;
}

const RecurrenceScopeModal: React.FC<RecurrenceScopeModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    description,
    itemDescription
}) => {
    const [selectedScope, setSelectedScope] = useState<RecurrenceScope>('onlyThis');

    const handleConfirm = () => {
        onConfirm(selectedScope);
        onClose();
    };

    const scopeOptions = [
        {
            value: 'onlyThis' as RecurrenceScope,
            label: 'Apenas esta cobrança',
            description: 'Apenas a cobrança selecionada será afetada.'
        },
        {
            value: 'nextOnes' as RecurrenceScope,
            label: 'Esta cobrança + futuras',
            description: 'A cobrança atual e todas as cobranças futuras desta recorrência serão afetadas.'
        },
        {
            value: 'all' as RecurrenceScope,
            label: 'Todas as cobranças',
            description: 'Todas as cobranças desta recorrência (passadas, atual e futuras) serão afetadas.'
        }
    ];

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-4">
                <p className="text-secondary-700">
                    {description}
                </p>

                {itemDescription && (
                    <div className="p-3 bg-secondary-50 rounded-lg border border-secondary-200">
                        <p className="text-sm text-secondary-600">
                            <strong>Cobrança:</strong> {itemDescription}
                        </p>
                    </div>
                )}

                <div className="space-y-3">
                    <p className="text-sm font-medium text-secondary-700">
                        Escolha o escopo da operação:
                    </p>

                    {scopeOptions.map((option) => (
                        <label key={option.value} className="flex items-start space-x-3 cursor-pointer">
                            <input
                                type="radio"
                                name="recurrenceScope"
                                value={option.value}
                                checked={selectedScope === option.value}
                                onChange={(e) => setSelectedScope(e.target.value as RecurrenceScope)}
                                className="mt-1 h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300"
                            />
                            <div className="flex-1">
                                <div className="text-sm font-medium text-secondary-900">
                                    {option.label}
                                </div>
                                <div className="text-xs text-secondary-500">
                                    {option.description}
                                </div>
                            </div>
                        </label>
                    ))}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn-secondary"
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        className="btn-primary"
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default RecurrenceScopeModal;




